<template>
  <a-modal
    :confirmLoading='confirmLoading'
    :title='title'
    :visible='visible'
    :width='1000'
    @cancel='handleCancel'
    @ok='handleOk'>
    <a-spin :spinning='confirmLoading'>
      <div>
        <a-form-model layout="horizontal" :model="model" v-bind="{ labelCol: { span: 6 }, wrapperCol: { span: 18 }, }" ref="ruleForm" :rules="rules">
          <a-row>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item class="label" prop="schemeName" label="方案名称">
                <a-input placeholder="请输入方案名称" v-model="model.schemeName" class="input" style="width: 233%;"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item label="所属科室" prop="departmentId">
                <a-select placeholder="请选择科室" v-model="model.departmentId" showSearch :filterOption="filterOption"
                  @change="deptChange">
                  <a-select-option :value="item.id" v-for="(item, index) in deptList" :key="index">{{ item.name
                    }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item label="所属亚专业" prop="subSpecialtyId">
                <a-select placeholder="请选择亚专业" v-model="model.subSpecialtyId" showSearch :filterOption="filterOption"
                  @change="subMajorChange">
                  <a-select-option :value="item.id" v-for="(item, index) in subMajorList" :key="index">{{ item.name
                    }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item label="所属病种" prop="diseaseTypeId">
                <a-select placeholder="请选择病种" v-model="model.diseaseTypeId" showSearch :filterOption="filterOption" @change="diseaseChange" style="width: 233%;">
                  <a-select-option :value="item.id" v-for="(item, index) in diseaseList" :key="index">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item class="label" prop="plannedGroupSize" label="入组人数">
                <a-input placeholder="请输入入组人数" v-model="model.plannedGroupSize" class="input"/>
              </a-form-model-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item class="label" prop="dailyEntryCount" label="每天入组人数">
                <a-input placeholder="请输入每天入组人数" v-model="model.dailyEntryCount" class="input"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item label="关键词">
                <a-select mode="tags" @change="keywordChange" v-model='model.keywordList' placeholder='请选择' >
                  <a-select-option :value='item' :key="item" v-for="item in model.keywordList">{{item}}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item class="label" prop="duration" label="时长">
                <a-input placeholder="请输入时长" v-model="model.duration" class="input"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item label="研究设计" prop="studyDesign">
                <a-select placeholder="请选择研究设计" v-model="studyDesignIds" showSearch mode="multiple" :filterOption="filterOption">
                  <a-select-option :value="item.id" v-for="(item, index) in researchDesignList" :key="index">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item label="研究类型" prop="studyType">
                <a-select placeholder="请选择研究类型" v-model="studyTypeIds" showSearch mode="multiple" :filterOption="filterOption">
                  <a-select-option :value="item.id" v-for="(item, index) in researchCategoryList" :key="index">{{ item.name }}</a-select-option>
                </a-select>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item label="研究设计说明" prop="studyDesignRemark" v-if="studyDesignIds.includes('6')">
                <a-input placeholder="请输入研究设计说明" v-model="studyDesignRemark" class="input"/>
              </a-form-model-item>
            </a-col>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item label="研究类型说明" prop="studyTypeRemark" v-if="studyTypeIds.includes('9')">
                <a-input placeholder="请输入研究类型说明" v-model="studyTypeRemark" class="input"/>
              </a-form-model-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12" :xxl="12">
              <a-form-model-item class="label" prop="remark" label="备注">
                <a-textarea :rows="4" placeholder="请输入备注" v-model="model.remark"  class="textarea" style="max-width: 233%; width: 233%;"/>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
  import baseRules from '@/constants/baseRules'
  import { getAction,postAction } from '@/api/manage'
  export default {
    name: 'SchemaModel',
    components: {  },
    data() {
      return {
        title: '表单选择',
        visible: false,
        model: {},
        confirmLoading: false,
        isEdit: false,
        rules:{
          schemeName:[baseRules.required],
          departmentId: [baseRules.required],
          subSpecialtyId: [baseRules.required],
          diseaseTypeId: [baseRules.required],
        },
        diseaseList: [],
        subMajorList: [],
        deptList: [],
        studyDesignIds: [],
        studyTypeIds: [],
        researchDesignList: [
          { id: '1', name: '病例对照研究' },
          { id: '2', name: '队列研究' },
          { id: '3', name: '横断面研究' },
          { id: '4', name: '随机对照试验' },
          { id: '5', name: '应用盲文' },
          { id: '6', name: '其他' }
        ],
        researchCategoryList: [
          { id: '1', name: '伴随诊断试剂盒研究' },
          { id: '2', name: '既往临床数据回顾性研究' },
          { id: '3', name: '既往临床标本回顾性研究' },
          { id: '4', name: '建立标本库研究' },
          { id: '5', name: '建立队列研究' },
          { id: '6', name: 'I类临床新技术(安全性、有效性确切，技术难度低、几乎不存在伦理风险的医疗技术)' },
          { id: '7', name: '既往个案病例报道' },
          { id: '8', name: '非植入性医疗器械研究(面罩、牙垫等)' },
          { id: '9', name: '其他(研究者判定，请说明:)' },
        ],
        studyDesignRemark: "",
        studyTypeRemark: ""
      }
    },
    created () {
      
    },
    methods: {
      add() {
        //初始化默认值
        this.edit({})
      },
      edit(record) {
        this.handleOpen(record,true)
      },
      view(record) {
        this.handleOpen(record,false)
      },
      handleOpen(record,edit){
        this.isEdit = edit
        this.model = Object.assign({}, record)
        this.visible = true

        if (this.model.studyDesign) {
          this.studyDesignIds = this.model.studyDesign.split(',')
        }
        if (this.model.studyType) {
          this.studyTypeIds = this.model.studyType.split(',')
        }

        let that = this;
        this.$nextTick(() => {
          that.handleEditMy();
        })  
      },
      close() {
        this.$emit('close')
        this.visible = false
      },
      handleOk() {
        if(this.formListVisible){
          this.formListVisible = false
        }
        else{
          this.submit()
        }
      },
      submit(){
        let that = this;

        this.$refs.ruleForm.validate(valid  => {
          if(valid){
            let studyDesign = that.studyDesignIds.map(id => {
              let result = { id: id, remark: "" };
              if (id === '6') {
                result.remark = that.studyDesignRemark;
              }

              return result;
            });
            let studyType = that.studyTypeIds.map(id => {
              let result = { id: id, remark: "" };
              if (id === '9') {
                result.remark = that.studyTypeRemark;
              }

              return result;
            });

            this.model.studyDesign = JSON.stringify(studyDesign);
            this.model.studyType = JSON.stringify(studyType);

            this.confirmLoading = true
            postAction('/scheme/save',this.model).then(res=>{
              if(res.success){
                this.$message.success(res.message)
                this.close()
              } else {
                this.$message.error(res.message)
              }
            }).finally(()=>{
              this.confirmLoading= false
            })
          }

        })

        // this.close()
      },
      handleCancel() {
        this.close()
      },

      filterOption(input, option) {
        return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
      },
      initDisease() {
        getAction('/tempconfig/tempConfigDisease/list', { pageSize: 2000 }).then(res => {
          if (res.success) {
            this.diseaseList = res.result.records
            this.diseaseList.unshift({ "id": "0", "name": "所有病种" })
          } else {
            this.$message.error('后台请求异常')
          }
        })
      },
      initDept() {
        getAction('/tempconfig/tempConfigDept/list', { pageSize: 2000 }).then(res => {
          if (res.success) {
            this.deptList = res.result.records
            this.deptList.unshift({ "id": "0", "name": "所有科室" })
          } else {
            this.$message.error('后台请求异常')
          }
        })
      },
      initSubMajor() {
        getAction('/tempconfig/tempConfigSubmajor/list', { pageSize: 2000 }).then(res => {
          if (res.success) {
            this.subMajorList = res.result.records
            this.subMajorList.unshift({ "id": "0", "name": "所有亚专业" })
          } else {
            this.$message.error('后台请求异常')
          }
        })
      },
      handleEditMy() {
        
        // this.initDisease()
        this.initDept()
        // this.initPeriod()
        // this.initSubMajor()

        this.deptChange()
        this.subMajorChange()
        // this.diseaseChange()

        if (this.model.id) {
          if (this.model.periodIdList && this.model.periodIdList.length > 0) {
            let periodList = []
            this.model.periodIdList.forEach(item => {
              periodList.push(item.id)
            })
            this.model.periodIdList = periodList
          }
        }
      },
      deptChange(vulue, option) {
        // let selectedOption = this.currentDeptOption;
        getAction('/tempconfig/tempConfigSubmajor/queryByDeptId', { id: this.model.departmentId }).then(res => {
          if (res.success) {
            this.subMajorList = res.result
            this.subMajorList.unshift({ "id": "0", "name": "所有亚专业" })
          }
        })
      },
      subMajorChange(vulue, option) {
        // let selectedOption = this.currentSubMajorOption;
        // console.log(selectedOption)
        getAction('/tempconfig/tempConfigDisease/queryByDeptIdAndSubMajorId', { deptId: this.model.departmentId, subMajorId: this.model.subSpecialtyId }).then(res => {
          if (res.success) {
            this.diseaseList = res.result
            this.diseaseList.unshift({ "id": "0", "name": "所有病种" })
          }
        })

      },
      diseaseChange(vulue, option) {
        if (this.model.type!='1') {
          // let selectedOption = this.currentDiseaseOption;
          if (this.model.diseaseId === "0") {
            this.model.moduleId = "0"
          } else {
            getAction('/tempconfig/tempConfigModule/queryByDiseaseId', { diseaseId: this.model.diseaseId }).then(res => {
              if (res.success) {
                this.model.moduleId = res.result.id
              }
            })
          }
        }
      },
      keywordChange(){
        this.$set(this.model,'keyword',this.model.keywordList.join(','))
      },
      dummyValidator(rule, value, callback) {
        callback();
      },
    }
  }
</script>

<style lang='less' scoped>
  .visit_name_row {
    margin-bottom: 8px;
  }
  .main-box {
    padding: 12px;
  }

  /deep/ .ant-table-small > .ant-table-content > .ant-table-body > table > .ant-table-tbody > tr > td  .ant-select-selection {
    border: 0!important;
  }
</style>
